import { useCallback } from 'react';
import { useCookieManagementEnabled } from '@namespace/cms/src/hooks/useCookieManagementEnabled';
import { useOtherSettings } from '@namespace/cms/src/hooks/useOtherSettings';
import { i18nActions } from '../../store';

const { SET_LANG_TRANSLATIONS } = i18nActions;

export const useChangeLanguage = () => {
  const otherSettings = useOtherSettings();
  const cookieManagementEnabled = useCookieManagementEnabled();

  const { isLoadFallbackTranslations } = otherSettings;

  const setNewLanguage = useCallback(
    async (lang) => {
      // language in url is synced in useSyncLangUrlStore hook!
      await SET_LANG_TRANSLATIONS({
        lang,
        cookieManagementEnabled,
        isLoadFallbackTranslations
      });
    },
    [cookieManagementEnabled, isLoadFallbackTranslations]
  );

  return [setNewLanguage];
};
